export const DEFAULT_BOT_NAME = "Sam";
export const DEFAULT_WIDGET_COLOR = "#252B42";
export const DEFAULT_BUBBLE_MESSAGE = "Hi! How can I help?"
export const CHAT_BOTS = new Set(["COSMO"]);
export const REQUIRED_FONT_TYPES = ["300", "regular", "500", "600", "700"];
export const GOOGLE_FONTS_API_URL =
  "https://www.googleapis.com/webfonts/v1/webfonts";
